<template>
    <div>
        <div class="modal fade" id="confirmarCheckInModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="marcacao">
                    <div class="modal-header">
                        <h5 class="modal-title">Check-In</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="lead">
                            {{ marcacao.dt_checkin ? 'Check-In Realizado' : 'Confirmar Check-In de...' }}
                        </div>
                        <div class="display-4">
                            {{ marcacao.nome_paciente }}
                        </div>

                        <template v-if="marcacao.tem_outras || lista_outros(marcacao).length">
                            <div class="row">
                                <div class="col col-12">
                                    <div class="input-group mb-3">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text">
                                                <input type="checkbox" aria-label="Checkbox for following text input"
                                                    v-model="faz_checkin_outros">
                                            </div>
                                        </div>
                                        <input type="text" class="form-control" disabled
                                            :value="'Fazer check-in também: ' + 
                                                ( recepcao 
                                                    ? 'outros procedimentos'
                                                    : lista_outros(marcacao).map(item => item.procedimento ? item.procedimento.search : item.id_marcacao).join(', ')
                                                )">
                                    </div>
                                </div>
                            </div>
                        </template>

                        <div class="d-flex flex-column my-3">

                            <az-input
                                type="button-group"
                                :optionsList="[
                                    { id: 'N', search: 'Atendimento Normal' },
                                    { id: 'P', search: 'Atendimento Preferencial' },
                                ]" 
                                v-model="tipo_atendimento" />

                        </div>

                        <div v-if="marcacao.tele_link">
                            <qr-code :text="marcacao.tele_link" :size="150" class="d-flex justify-content-center my-3"></qr-code>
                            <div class="text-center">
                                <small>QR Code para Pré-Cadastro</small>
                            </div>
                        </div>

                        <div class="card mt-3" v-if="marcacao.campos_customizados && marcacao.campos_customizados.js_campos && marcacao.campos_customizados.js_campos.length">
                            <div class="card-header">
                                {{ marcacao.campos_customizados.st_titulo }}
                            </div>
                            <div class="card-body">
                                <formulario 
                                    :gutters="true" 
                                    v-model="marcacao.campos_customizados.js_campos" 
                                    :saved="true" 
                                    mode="fixed"
                                    :validate="validate"
                                    :config="true" />
                            </div>
                        </div>

                        <div v-if="recepcao_subs && recepcao_subs.length > 1" class="mt-3">
                            <az-input   
                                icon="fa-solid fa-bell-concierge"
                                type="select"
                                :optionsList="recepcao_subs"
                                optionsData="id_recepcao"
                                placeholder="Selecione a Recepção..."
                                required
                                :validate="validate"
                                v-model="id_sub_recepcao" />
                        </div>

                        <pre v-if="false">{{ recepcao_subs }}</pre>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit v-if="!marcacao.dt_checkin" @click="confirmar()">Confirmar Check-In</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import Formulario from '../../modulos/consultorio/Formulario.vue';

export default {
    data() { 
        return { 
            marcacao: null, 
            tipo_atendimento: null, 
            faz_checkin_outros: this.$util.getCookie('faz-chk-out') == 'N' ? false : true, 
            id_sub_recepcao: "", 
            validate: false, 
        };
    },

    components: { 
        AzInput,
        AzSubmit, 
        Formulario, 
    },

    computed: { 
        recepcao_subs: function () { 
            let recep = this.$util.recepcao();
            return ( recep && recep.subs ) 
                ? recep.subs.filter(sub => sub.fl_ativo) 
                : [];
        }
    },

    props: ['lista', 'recepcao'], 

    methods: { 
        remover_checkin (marcacao) { 
            if ( !confirm('Confirma a remoção check-in realizado?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'marcacoes',
                func: 'cerimonial_remover',
                dados: { 
                    id_marcacao: marcacao.id_marcacao,
                    outras: this.lista_outros(marcacao),
                },
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

        obter_unidade_recepcao() { 
            let id_unidade_operacao = this.$util.getCookie('id_unidade_operacao');
            let id_recepcao = this.$util.getCookie('id_recepcao');
            const unidade = this.$store.state.unidade;

            if ( unidade && unidade.unidade_operacaos && unidade.unidade_operacaos.length == 1 ) { 
                id_unidade_operacao = unidade.unidade_operacaos[0].id_unidade_operacao;

                if ( unidade.unidade_operacaos[0].recepcaos.length == 1 ) { 
                    id_recepcao = unidade.unidade_operacaos[0].recepcaos[0].id_recepcao;
                }
            }

            return { 
                id_unidade_operacao: id_unidade_operacao,
                id_recepcao: id_recepcao,
            };
        },

        realizar_check_in(marcacao) { 
            this.marcacao = null;
            this.validate = false; 

            this.id_sub_recepcao = this.$util.getCookie('cer-chk-sub-rec');

            if ( this.id_sub_recepcao ) { 
                if ( this.recepcao_subs && this.recepcao_subs.find(sub => sub.id_recepcao == this.id_sub_recepcao ) ) { 
                    //
                } else { 
                    this.id_sub_recepcao = "";
                }
            }
            
            this.$nextTick(() => { 
                this.marcacao = marcacao;
                this.tipo_atendimento = this.marcacao.fl_preferencial ? 'P' : 'N';
                
                $('#confirmarCheckInModal').modal('show');
            });
        },

        lista_outros (marcacao) { 
            if ( marcacao.outras && marcacao.outras.length > 1 )
                return marcacao.outras.filter(item => item.id_marcacao != marcacao.id_marcacao);

            if ( marcacao.outras_cad_temp && marcacao.outras_cad_temp.length > 1 )
                return marcacao.outras_cad_temp.filter(item => item.id_marcacao != marcacao.id_marcacao);

            if ( !this.lista )
                return [];

            return this.lista.filter(item => item.id_marcacao != marcacao.id_marcacao
                && !marcacao.dt_checkin 
                && ( marcacao.id_paciente || marcacao.id_cadastro_temporario ) 
                && ( ( marcacao.id_paciente && marcacao.id_paciente == item.id_paciente )
                    || ( marcacao.id_cadastro_temporario && marcacao.id_cadastro_temporario == item.id_cadastro_temporario ) ) );
        },

        confirmar() { 
            const unidade_recepcao = this.obter_unidade_recepcao();

            this.$util.setCookie('faz-chk-out', this.faz_checkin_outros ? 'S' : 'N');

            let outros = this.faz_checkin_outros 
                ? this.lista_outros(this.marcacao).map(item => item.id_marcacao)
                : [];

            let outros_parms = { 
                id_unidade_operacao: unidade_recepcao ? unidade_recepcao.id_unidade_operacao : null, 
                id_recepcao: this.id_sub_recepcao 
                    ? this.id_sub_recepcao 
                    : unidade_recepcao ? unidade_recepcao.id_recepcao : null,
            };

            if ( this.id_sub_recepcao ) { 
                this.$util.setCookie('cer-chk-sub-rec', this.id_sub_recepcao, 5);
            }

            this.$util.atualizar(this, { 
                service: 'marcacoes',
                func: 'cerimonial_checkin',
                dados: { 
                    id_marcacao: this.marcacao.id_marcacao, 
                    ...outros_parms, 
                    tipo_atendimento: this.tipo_atendimento, 
                    outros: outros, 
                    faz_checkin_outros: this.faz_checkin_outros, 
                    campos_customizados: this.marcacao.campos_customizados,
                },
                modal: 'confirmarCheckInModal',
                toast: true,
                callback: res => { 

                    if ( res && res.expresso ) { 
                        this.marcacao.expresso = res.expresso;
                        this.marcacao.dt_checkin = res.dt_checkin;
                        this.marcacao.fl_preferencial = res.fl_preferencial;

                        this.$forceUpdate();
                    } else { 
                        this.$emit('refresh');
                    }

                    if ( process.env.VUE_APP_GTAG ) { 

                        let action = 'check-in-cerimonial';
                        let label = this.marcacao.id_marcacao;
                        
                        this.$gtag.event(action, {
                            'event_category': window.redir,
                            'event_label': label,
                            'value': 1
                        });

                    }

                }

            });
        }
    }
}
</script>